import React from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

const MultiSelect = ({name, label, options, limit, required, error, control, onChange}) => {
  const resultValues = (values) => {
    return limit ? values.slice(0, limit) : values
  }

  const updateValues = (field, values) => {
    field.onChange(resultValues(values))
    onChange && onChange(values)
  }

  return <label className='team-label'>
    {label}
    <Controller
      control={control}
      name={name}
      rules={{ required: (required ? 'Is required' : false) }}
      render={({ field }) => (
        <Select
          multi
          value={field.value}
          options={options}
          onChange={values => updateValues(field, values)}
        />
      )}
    />
    {error && <div className='error_container'>{error.message}</div>}
  </label>
}

export default MultiSelect
